import { useAbility } from '../../users/AbilityContext';
import { RoleBehaviorCapability } from '../../users/ability.types';

const useCanManageBrandCatalogs = () => {
  const ability = useAbility();

  return ability.hasCapability(RoleBehaviorCapability.CATALOGS_MANAGE_BRAND_CATALOGS);
};

export default useCanManageBrandCatalogs;
